import { CAP_LEVELS } from '../domain/CapLevels';
import { DEFAULT_CAP_LEVEL_COLOR_GREY } from '../constants/SessionConstants';

const CONSTANTS = {
  FIRST_CAP_LEVEL_INDEX: 0,
};

export const determineCapLevelHelper = (content) => {
  if (!content || content.length === 0) {
    return { name: '', color: DEFAULT_CAP_LEVEL_COLOR_GREY };
  }

  const getCapLevel = (capLevelKey) => {
    const matchingCapLevel = CAP_LEVELS.find(
      (capLevel) => capLevel.key === capLevelKey || capLevel.name === capLevelKey
    );
    
    return {
      name: matchingCapLevel?.name || '',
      color: matchingCapLevel?.color || DEFAULT_CAP_LEVEL_COLOR_GREY,
    };
  };

  if (Array.isArray(content)) {
    const levels = content.map((c) => c.level);
    const allLevelsSame = levels.every(
      (level) => level === levels[CONSTANTS.FIRST_CAP_LEVEL_INDEX]
    );
    return allLevelsSame
      ? getCapLevel(levels[CONSTANTS.FIRST_CAP_LEVEL_INDEX])
      : { name: '', color: DEFAULT_CAP_LEVEL_COLOR_GREY };
  }

  return getCapLevel(content.level);
};